export const deleteCookie = (name: string, path?: string, domain?: string) => {
    if (getCookie(name)) {
        document.cookie = name + "=" +
            ((path) ? ";path=" + path : "") +
            ((domain) ? ";domain=" + domain : "") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}

export const setCookie = (name: string, value: string, hours?: number, path: string = "/", domain?: string) => {
    let expires: string = "";
    if (hours) {
        const date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    const result = [name + "=" + (value || "") + expires]
    result.push("path=" + path);
    if (domain) {
        result.push("Domain=" + domain);
    }
    document.cookie = result.join('; ');
}

export const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return "";
}